import effectManager from '../../module/effect';

let effect = new effectManager();

export default class businessTabManager {
    constructor() {

        this.$container;
        this.$trigger;
        this.$contentsWrap;
        this.$contents;

        this.$spTrigger;

        this.status = {
            current: 0,
            prevCurrent: 0,
            flg: false,
        }

    }

    init(scroll) {

        this.$container = document.getElementById("js__pc-tab");
        this.$trigger = this.$container.querySelectorAll(".js__pc-tab-trigger");
        this.$contentsWrap = this.$container.querySelector(".js__pc-tab-contentsWrap");
        this.$contents = this.$container.querySelectorAll(".js__pc-tab-contents");
        this.$spTrigger = document.getElementById("js__sp-select");

        TweenMax.set(this.$contents, {
            opacity: 0,
            zIndex: 0,
        });
        TweenMax.set(this.$contents[this.status.current], {
            opacity: 1,
            zIndex: 1,
        });

        // this.$contentsWrap 高さを取得
        this.resize();

        // PC
        for (let i in this.$trigger) {
            if (this.$trigger[i].nodeType !== 1) break;
            this.$trigger[i].addEventListener("click", (e) => {
                this.change(e.target.getAttribute("data-target"), scroll);
            });
        }

        // SMP
        this.$spTrigger.addEventListener("change", (e) => {
            this.change(e.target.value, scroll);

        });


    }

    change(select, scroll) {
        if (this.status.flg || this.status.current === Number(select)) return;

        this.status.flg = true;

        this.status.prevCurrent = this.status.current;
        this.status.current = Number(select);

        this.$trigger[this.status.prevCurrent].classList.remove("is-current");
        this.$trigger[this.status.current].classList.add("is-current");
        this.changeMot(scroll);
    }

    changeMot(scroll) {
        this.$contents[this.status.prevCurrent].classList.remove("is-current");

        TweenMax.to(this.$contents[this.status.prevCurrent], 0.4, {
            opacity: 0,
            zIndex: 0,
            onComplete: () => {
                this.resize();
                this.status.flg = false;
                this.$contents[this.status.current].classList.add("is-current");
                TweenMax.to(this.$contents[this.status.current], 0.8, {
                    opacity: 1,
                    zIndex: 1,
                    onComplete: () => {
                        scroll.resize();
                    }
                });
            }
        });
    }

    resize() {

        TweenLite.set(this.$contentsWrap, {height: this.$contents[this.status.current].getBoundingClientRect().height})

    }
}
